import { useState } from "react";
import {
    StyleSheet,
    Text,
    View,
    Pressable,
    Image,
    ScrollView,
    SafeAreaView,
    TextInput,
} from "react-native";
import { BaseButton } from "../components/BaseButton";
import { BaseInput } from "../components/BaseInput";
import { BaseLargeText } from "../components/BaseLargeText";
import { colors } from "../constants/colors";
import { registerUserWithEmailAndPassword } from "../services/firebase/auth_email";

export default function RegistrationScreen() {
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [name, setName] = useState(null);

    const logIn = () => {
        if (email && password)
            registerUserWithEmailAndPassword({ email, password, name });
    }

    return (<View style={{ flex: 1, backgroundColor: colors.brightBlue, padding: 20, }}>
        <View style={{ height: '20%' }} />
        <BaseLargeText style={{ color: colors.white, alignSelf: 'center', marginVertical: 40 }}>Logi sisse </BaseLargeText>
        <BaseInput label="email" placeholder="nt email@gmail.com" value={email} onChangeText={setEmail} />
        <BaseInput secureTextEntry={true} label="parool" placeholder="sisesta parool" value={password} onChangeText={setPassword} />
        <BaseInput label="eesnimi" placeholder="sisesta eesnimi" value={name} onChangeText={setName} />
        <BaseButton text="Edasi" containerStyle={{ backgroundColor: colors.darkPurple, marginTop: 20, shadowColor: colors.darkPurple }} textStyle={{ color: 'white' }} onPress={logIn} medium />
    </View>)

}
